exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-tag[data-v-09b35352] {\n  margin: 5px 10px;\n}\n.pagination-wrap[data-v-09b35352] {\n  text-align: right;\n  padding-top: 20px;\n}\n.strong-text[data-v-09b35352] {\n  font-weight: bold;\n}\n.single-line-container[data-v-09b35352] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n.expanded-container[data-v-09b35352] {\n  white-space: normal;\n  word-wrap: break-word;\n  max-width: 100%;\n}\n", ""]);

// exports
